(function () {
  function initDemoVideo(root) {
    if (root.dataset.demoVideoInit === 'true') return;
    root.dataset.demoVideoInit = 'true';

    const button = root.querySelector('[data-demo-video-play]');
    const template = root.querySelector('template[data-demo-video-template]');
    if (!button || !template) return;

    button.addEventListener('click', () => {
      root.appendChild(template.content.cloneNode(true));
      const video = root.querySelector('video');
      root.classList.add('is-playing');
      button.hidden = true;
      if (!video) return;
      video.focus();
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(() => { /* controls stay available */ });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-demo-video]').forEach(initDemoVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => initAll(e.target));

  window.DemoVideo = { init: initDemoVideo, initAll };
})();
